export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10025.ab9106ef.jpg";